import { render, staticRenderFns } from "./CompanyCard2.vue?vue&type=template&id=cc95483a&scoped=true&"
import script from "./CompanyCard2.vue?vue&type=script&lang=js&"
export * from "./CompanyCard2.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCard2.vue?vue&type=style&index=0&id=cc95483a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc95483a",
  null
  
)

export default component.exports